/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientLocationResponseDto } from '../models/ClientLocationResponseDto';
import type { SaveClientLocationDto } from '../models/SaveClientLocationDto';
import type { UpdateClientLocationDto } from '../models/UpdateClientLocationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppService {
    /**
     * Get my client profile
     * Returns the authenticated client profile.
     * @returns any Client profile fetched successfully
     * @throws ApiError
     */
    public static clientAppControllerGetMyProfileV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/me',
        });
    }
    /**
     * Save a new client location
     * Creates a new saved location for the authenticated client. If marked as primary, this location will become the active location for searches.
     * @param requestBody Payload to create a new client location
     * @returns ClientLocationResponseDto Location created successfully
     * @throws ApiError
     */
    public static clientAppControllerSaveLocationV1(
        requestBody: SaveClientLocationDto,
    ): CancelablePromise<ClientLocationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error in location payload`,
                401: `Unauthorized - JWT is missing or invalid`,
            },
        });
    }
    /**
     * Get all client locations
     * Returns all saved locations for the authenticated client.
     * @returns ClientLocationResponseDto Locations fetched successfully
     * @throws ApiError
     */
    public static clientAppControllerGetLocationsV1(): CancelablePromise<Array<ClientLocationResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/locations',
            errors: {
                401: `Unauthorized - JWT is missing or invalid`,
            },
        });
    }
    /**
     * Update a client location
     * Updates fields of an existing client location. If is_primary is set to true, this location becomes the active location.
     * @param id ID of the client location to update
     * @param requestBody Payload to update the client location
     * @returns ClientLocationResponseDto Location updated successfully
     * @throws ApiError
     */
    public static clientAppControllerUpdateLocationV1(
        id: string,
        requestBody: UpdateClientLocationDto,
    ): CancelablePromise<ClientLocationResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/client-app/locations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error in location payload`,
                401: `Unauthorized - JWT is missing or invalid`,
                404: `Location not found for this client`,
            },
        });
    }
    /**
     * Delete a client location
     * Deletes a saved location for the authenticated client.
     * @param id ID of the client location to delete
     * @returns any Location deleted successfully
     * @throws ApiError
     */
    public static clientAppControllerDeleteLocationV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/client-app/locations/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized - JWT is missing or invalid`,
                404: `Location not found for this client`,
            },
        });
    }
}
